import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ServicesModule } from 'src/app/services/services.module';
import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login.component';

@NgModule({
  declarations: [LoginComponent],
  imports: [CommonModule, LoginRoutingModule, ServicesModule]
})
export class LoginModule {}
